import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "products-page-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "products-page-inner"
}
const _hoisted_3 = { class: "product-card-header" }
const _hoisted_4 = { class: "product-name" }
const _hoisted_5 = {
  key: 0,
  class: "product-subname"
}
const _hoisted_6 = { class: "product-card-body" }
const _hoisted_7 = {
  key: 0,
  class: "product-info-col"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "product-card-footer" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_ProductGallery = _resolveComponent("ProductGallery")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: (_ctx.blockData && _ctx.blockData.page_title),
      subtitle: (_ctx.blockData && _ctx.blockData.custom_subheader) || ''
    }, null, 8 /* PROPS */, ["title", "subtitle"]),
    (_ctx.blockData && _ctx.blockData.products)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockData.products, (product) => {
            return (_openBlock(), _createElementBlock("div", {
              key: product.id,
              class: _normalizeClass(["product-row", { 'wide-card': product.description && product.description.trim() !== '' }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(product.name), 1 /* TEXT */),
                (product.subname)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(product.subname), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (product.description && product.description.trim() !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: "product-description",
                        innerHTML: product.description
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_ProductGallery, {
                  images: product.images,
                  "active-image": _ctx.getActiveImage(product),
                  "product-name": product.name,
                  description: product.description,
                  onChangeImage: (img) => _ctx.setActiveImage(product.id, img)
                }, null, 8 /* PROPS */, ["images", "active-image", "product-name", "description", "onChangeImage"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (product.youtube_primary_link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: product.youtube_primary_link,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "btn-youtube"
                    }, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: "/wp-content/themes/rufousone/img/youtube-bttn-small.jpg",
                        alt: "Watch Review"
                      }, null, -1 /* CACHED */)
                    ]))], 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("a", {
                  href: product.amazon_url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "buy-now-btn"
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: "/wp-content/themes/rufousone/img/amazon-bttn.png",
                    alt: "Buy on Amazon"
                  }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_11)
              ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}